export const divideArrays = (data: any[]) => {
	if (!Array.isArray(data)) {
		throw new Error('Array must be an array.');
	}
	// const half = Math.ceil((data.length + 1) / 2);
	const half = Math.floor(data.length / 2);
	const firstArray = data.slice(0, half);
	const secondArray = data.slice(half, data.length);
	return [firstArray, secondArray];
};
